module.exports = __webpack_public_path__ + "static/media/category-banner1.81508b24.png";